module.exports = __webpack_public_path__ + "static/media/win_pc.6c4a4de0.svg";